import { IraType } from '../../types';
import { IconName } from '../icons';

export const iconNameByIraType: Record<IraType, IconName> = {
    TRADITIONAL: 'TraditionalIRA',
    ROTH: 'GoalRetirement',
};
